module.exports = __webpack_public_path__ + "img/icon-gift-coupon.04fd3a77.svg";